import React from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar from '../../components/Sidebar';

const groups = [
  {
    label: 'Platform',
    links: [
      { to: '/admin', label: 'Overview', end: true },
      { to: '/admin/networks', label: 'Networks' },
      { to: '/admin/rpc-providers', label: 'RPC Providers' },
      { to: '/admin/method-costs', label: 'Method Costs' },
      { to: '/admin/plans', label: 'Plans' },
      { to: '/admin/users', label: 'Users' },
      { to: '/admin/deposits', label: 'Deposits' },
      { to: '/admin/rpc-logs', label: 'RPC Logs' },
    ],
  },
];

export default function AdminLayout() {
  return (
    <div className="app-shell">
      <Sidebar groups={groups} />
      <main className="app-content">
        <Outlet />
      </main>
    </div>
  );
}
